// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__Stg4S","row":"styles_row__36Ebe"};